module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-bottom"
  }, _vm._l((_vm.navList), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "shop-bottom-item click",
      class: _vm.navValue == item.value ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.toState(item.url)
        }
      }
    }, [_c('span', {
      staticClass: "alifont",
      class: item.icon
    }), _vm._v("\n        " + _vm._s(item.name) + "\n    ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c3cffee","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/equipment/equipment-navs.vue
// module id = ykiu
// module chunks = 51